export default __webpack_public_path__ + "static/media/8.e831fe18.jpg";